import React from 'react'
import './SchoolPartnership.css'
import icon1 from '../../assetsS/images/one.png'
import icon2 from '../../assetsS/images/two.png'
import Photo1 from '../../assetsS/images/back1.png'

export default class TextonImage extends React.Component {
  state = {}

  updateDetails() {
    this.props.handleStateChange(this.state)
  }

  componentWillReceiveProps(newProps) {
    this.setState(newProps)
  }

  componentDidMount = async () => {
    this.setState(this.props)
  }

  render() {
    const isBgImg = this.state.isBgImg

    const points = [
      {
        icon: icon1,
        text: 'Each teacher can log in the list of chapter that they teach for the week and generate test based on that and assign it to student',
      },
      {
        icon: icon2,
        text: 'Reduce time and effort put in for the answer paper correction',
      },
    ]

    return (
      <div
        className="homebannerimgcomp111new"
        style={{ backgroundImage: `url(${Photo1})` }}
      >
        <div className="biochamp-overlay">
          <div className="container">
            <div className="biochamp-points">
              {points.map((point, i) => (
                <div key={i} className="biochamp-point">
                  <div className="biochamp-point__icon-wrap">
                    <img src={point.icon} alt="" className="biochamp-point__icon" />
                  </div>
                  <p className="biochamp-point__text">{point.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    )
  }
}